import type { AtomModel } from '@models/atom.model';

import type { TableEditorSelectColumnData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<TableEditorSelectColumnData>;
};

export const SelectSettingsModal = ({ atom }: Props) => {
  atom;
  return <></>;
};
